'use strict';

angular.module('internal.trainings', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // internal routings
            // trainings tab            
            .state('internal.licensing.training', {
                abstract: true,
                templateUrl: paths.app + 'trainings/components/training/training.html',
                controller: 'InternalTraining',
                params: {
                    id: null,
                    training: null
                }
            })
                .state('internal.licensing.training.notes', {
                    url: '/training/:id/notes',
                    templateUrl: paths.app + 'trainings/components/training-notes/training-notes.html',
                    controller: 'InternalTrainingNotes',
                    params: {
                        id: null,
                        training: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.training.note', {
                    url: '/training/:id/note/:trainingNoteID',
                    templateUrl: paths.app + 'trainings/components/training-note/training-note.html',
                    controller: 'InternalTrainingNote',
                    params: {
                        id: null,
                        training: null,
                        trainingNoteID: null,
                        training_note: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.trainingNoteID == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.licensing.training.notes').then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
    }])
;